// extracted by mini-css-extract-plugin
export var button = "_8i-0";
export var icon = "_8i-1";